import React, { useEffect } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { Plus } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { CollectionLoader, UnitTitleBlock } from "lib/components"
import Content from "./Content"


export default function ContentPage(){

  const [ searchParams, setSearchParams ] = useSearchParams()

  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()
  
  const { data:_Contents } = queryTools.resource.parseQueryForApi("content.findAll", {})
  const saveFn = queryTools.resource.save(["content.all"])

  const handleItemSelect = (item:any) => {
    if( searchParams.get("id") !== null ) {
      console.log("hmm...")
    } else {
      setSearchParams({ id: item._id })
    }
  }

  const loadEmptyContent = () => setSearchParams({ id: "0" })

  useEffect(() => {

  },[searchParams])

  return (
    <div className="w-full flex flex-col justify-start items-start gap-6">

      <div className="w-full">
        <UnitTitleBlock 
          onClick={() => setSearchParams({})}
          className="left-[10px] w-[calc(100%+10px)] mb-0" 
          title="content manager"
        >
          <Plus className="size-5 cursor-pointer stroke-1 stroke-gray-100" onClick={loadEmptyContent} />
        </UnitTitleBlock>
      </div>

      <div className="w-full text-sm text-neutral-200 my-2 pl-2">
        <p>Many of our templates re-use the same content items over and over again. Save those items here and never have to type them again!</p>
      </div>

      <div className="w-full flex gap-4 h-full max-h-[54rem]">
        
        <div className="w-2/12 flex border border-solid border-slate-700 h-[40rem] overflow-y-auto scrollbar">
          <CollectionLoader 
            collection={_Contents}
            selectFn={(item:any) => setSearchParams({ id: item._id })}
            selectProp="_id"
            labelProp="title"
            className="w-full"
            showDescriptions={true}
          />
        </div>

        <div className="w-10/12 items-stretch">
          <Content />
        </div>

      </div>
  
    </div>
  )
}